import React from "react";

export default function PropertyTableInventorySkeleton() {
  return (
    <div className="mt-3 flex flex-col">
      <div className="overflow-x-auto overscroll-x-contain rounded-lg bg-white shadow-sm ring-1 ring-black ring-opacity-5">
        <table className="min-w-full sm:divide-y sm:divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-2 py-3 text-left text-xs font-medium tracking-wide text-gray-900 sm:pl-6"></th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Tipo de propiedad
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Inmobiliaria
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Teléfono
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Ubicación
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Promotor
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Comisión compartida
              </th>
              <th
                scope="col"
                className="px-2 py-3 text-left text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Precio
              </th>
              <th
                scope="col"
                className="px-1 py-3 text-center text-xs font-semibold text-gray-900 sm:text-sm"
              >
                Descargar PDF
              </th>
            </tr>
          </thead>
          <tbody className="bg-white animate-pulse">
            {[...Array(5)].map((_, i) => (
              <tr key={i} className={i % 2 === 0 ? undefined : "bg-gray-50"}>
                <td className="px-2 py-2 align-middle sm:pl-6">
                  <div className="h-16 w-16 rounded-lg bg-gray-300 sm:h-[100px] sm:w-[100px] md:h-[120px] md:w-[120px]" />
                </td>
                <td className="px-2 py-3 sm:px-3">
                  <div className="flex gap-1">
                    <div className="flex flex-col space-y-2">
                      <div className="h-4 w-16 bg-gray-300 rounded" />
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                    </div>
                  </div>
                </td>
                <td className="px-2 py-3">
                  <div className="h-5 w-20 bg-gray-300 rounded-md sm:ml-3" />
                </td>
                <td className="px-2 py-3">
                  <div className="h-4 w-24 bg-gray-300 rounded sm:ml-3" />
                </td>
                <td className="relative px-2 py-3 sm:pr-6">
                  <div className="h-5 w-48 bg-gray-300 rounded" />
                </td>
                <td className="relative px-2 py-3 sm:pr-6">
                  <div className="h-5 w-32 bg-gray-300 rounded" />
                </td>
                <td className="relative px-2 py-3 sm:pr-6">
                  <div className="h-5 w-32 bg-gray-300 rounded" />
                </td>
                <td className="px-2 py-3">
                  <div className="flex flex-col space-y-2">
                    <div className="h-4 w-24 bg-gray-300 rounded" />
                    <div className="h-4 w-24 bg-gray-300 rounded" />
                    <div className="h-4 w-24 bg-gray-300 rounded" />
                  </div>
                </td>
                <td className="relative px-1 py-3">
                  <div className="flex items-center justify-center">
                    <div className="h-5 w-5 bg-gray-300 rounded" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
